
import {
  REQUEST_BILLING_COUNTS_FOR_PAST_X_MONTHS,
  REQUEST_BILLING_COUNTS_FOR_PAST_X_MONTHS_ERROR,
  RECEIVE_BILLING_COUNTS_FOR_PAST_X_MONTHS
} from 'actions'

export default function (state = {}, action) {
  const { type, payload = {} } = action

  // payload can be any type, includ null (https://github.com/acdlite/flux-standard-action#payload)
  // here, if payload === null, this reducer throws
  if (payload === null) return state

  const key = `${payload.workspaceSlug}:${payload.monthsAgo}`
  switch (type) {
    case REQUEST_BILLING_COUNTS_FOR_PAST_X_MONTHS:
      return {
        ...state,
        [key]: {
          isRequesting: true,
          didRequestFail: false,
          didRequest: false,
          data: {}
        }
      }
    case RECEIVE_BILLING_COUNTS_FOR_PAST_X_MONTHS:
      return {
        ...state,
        [key]: {
          isRequesting: false,
          didRequestFail: false,
          didRequest: true,
          data: payload.data
        }
      }
    case REQUEST_BILLING_COUNTS_FOR_PAST_X_MONTHS_ERROR:
      return {
        ...state,
        [key]: {
          isRequesting: false,
          didRequestFail: true,
          didRequest: true,
          data: {}
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/mtus/past-x-months.js